<icc-select-box
  [title]="selectedHandle?.name"
  [description]="selectedHandle?.description"
  [imageUrl]="selectedHandleImg"
></icc-select-box>

<mat-card appearance="outlined" class="mat-elevation-2">
  @if (!outerColorAsMainColor) {
    <div>
      <p>{{ 'WINDOW|Wybierz kolor:' | translate }}</p>
      <icc-list [items]="colors" itemTemplate="itemColor" [scrollable]="false" [selected]="selHandleColor" (select)="selectHandleColor($event)">
      </icc-list>
    </div>
  }

  @if (outerColorAsMainColor) {
    <div>
      <p>{{ 'WINDOW|Wybierz kolor:' | translate }}</p>
      <icc-list [items]="colors" itemTemplate="itemColor" [scrollable]="false" [selected]="selHandleOuterColor" (select)="selectHandleColor($event, true)">
      </icc-list>
    </div>
  }

  @if (availableColorOuter && !outerColorAsMainColor) {
    <div>
      <mat-slide-toggle [formControl]="selectColorOuter">{{ 'WINDOW|Wybierz kolor na zewnątrz:' | translate }}</mat-slide-toggle>
      <small>{{ 'WINDOW|Ta opcja pozwala wybrać inny kolor dla klamki zewnętrznej' | translate }}</small>
      @if (selectColorOuter.value) {
        <icc-list [items]="colors" itemTemplate="itemColor" [scrollable]="false" [selected]="selHandleOuterColor" (select)="selectHandleColor($event, true)">
        </icc-list>
      }
    </div>
  }
</mat-card>

@if (showHeightSelect && handleHeights.length && (!config().IccConfig.Configurators.loweredHandlerHeights || config().preset === 'b2b' || availableLoweredHandleHeight) && (confType != 'hs' && confType != 'sliding_door' && confType != 'door' || systemHeight)) {
  <mat-card appearance="outlined" class="mat-elevation-2">
    @if (sashType == 'K' && config().IccConfig.Configurators.handlePositionInUType) {
      <mat-form-field>
        <mat-select [(ngModel)]="position" [placeholder]="'WINDOW|Pozycja klamki' | translate">
          <mat-option value='T'>{{ 'WINDOW|montaż u góry' | translate }}</mat-option>
          <mat-option value='R'>{{ 'WINDOW|montaż po prawej' | translate }}</mat-option>
          <mat-option value='L'>{{ 'WINDOW|montaż po lewej' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    }
    @if (position != 'T' && config().IccConfig.Configurators.handlePosition && (!config().IccConfig.Configurators.loweredHandlerHeights || config().preset === 'b2b')) {
      <mat-form-field>
        <mat-select [ngModel]="handleHeight" [placeholder]="'WINDOW|Wysokość klamki:' | translate" (ngModelChange)="setHandleHeight($event)">
          @for (height of handleHeights; track height) {
            <mat-option [value]="height.height">{{height.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (availableLoweredHandleHeight) {
      <mat-checkbox [(ngModel)]="isLoweredHandleHeight">
        {{ 'WINDOW|Obniżona klamka' | translate }}
      </mat-checkbox>
    }
    @if (position != 'T' && config().IccConfig.Configurators.handlePosition && handleHeight === 'nonstandard') {
      <mat-form-field>
        <input matInput iccDimensionInput [(ngModel)]="customHandleHeight" [min]="minHandleHeight" [max]="maxHandleHeight" style="width: 70px" [placeholder]="'WINDOW|Niestandardowa wysokość klamki:' | translate" >
        <!-- {{$root.user.dimension_unit}} -->
      </mat-form-field>
    }
  </mat-card>
}

<button mat-raised-button color="primary" (click)="save()"
>{{ 'INTERFACE|OK' | translate }}</button>
